class MultipleProducts {
  constructor(options) {
    this.box = document.querySelector(options.classBox)

    this.prevBtn = this.box.querySelector('.left .prev')
    this.nextBtn = this.box.querySelector('.left .next')
    this.cartBtn = this.box.querySelector('.left .cart')
    this.price = this.box.querySelector('.right .price')
    this.priceTotal = 0
    this.liList = this.box.querySelectorAll('.classification li')
    this.contentList = this.box.querySelectorAll('.content .product-box')
    this.contentDataList = {}

    // 购物车数据
    this.cartList = {}

    this.cartListType = []
    this.cartViewList = this.box.querySelector('.right .ul')
    this.addCartBtn = this.box.querySelector('.right .r-add-cart')
    // 当前 索引
    this.currentNum = 0
    this.currentInfoList = {}
    // 弹窗
    this.popupText = this.box.querySelector('.popup-box')
    this.popupBtnOk = this.box.querySelector('.popup-box .btn-ok')

    // 手机侧边按钮
    this.btnCart = this.box.querySelector('.btn-cart')

    this.options = options

    this.swiperContentBox = null

    this.initUlContent()
    this.init()

    this.initViewClassification()
    this.initViewUl()
    this.viewKit()

    this.updateNextBtnView()

    this.initSwiper()
    setTimeout(() => {
      this.initPopupText(this.currentNum)
    }, 5000)
  }

  init () {
    this.prevBtn.addEventListener('click', () => {
      this.prevBtnEvent()
    })

    this.nextBtn.addEventListener('click', () => {
      this.nextBtnEvent()
    })

    const addCartBtnEvent = (cartList) => {
      if (!Object.keys(this.cartList).length) {
        return
      }
      this.addCartStatus(true)

      const arr = []
      Object.keys(cartList).forEach((i, index) => {
        const item = cartList[i].value
        const o = {
          'id': item.variants[0].id + '',
          'quantity': cartList[i].quantity
        }
        arr.push(o)
      })

      event(arr)
    }

    const event = (o) => {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: o
        })
      })
        .then(response => {
          return response.json();
        }).then(() => {
          this.addCartStatus(false)
          // setTimeout(() => {
          //   window.location.href = '/cart'
          // }, 200)
        })
    }

    this.cartBtn.addEventListener('click', () => {
      addCartBtnEvent(this.cartList)
    })

    this.addCartBtn.addEventListener('click', () => {
      addCartBtnEvent(this.cartList)
    })

    setTimeout(() => {
      this.popupBtnOk.addEventListener('click', () => {
        this.popupText.style.display = 'none'
      })
    })
  }

  nextBtnEvent () {
    this.currentNum++
    if (this.currentNum > 0) {
      this.prevBtn.classList.remove('disabled')
      this.prevBtn.removeAttribute('disabled')
    }

    this.initViewClassification()
    this.initViewUl()
    this.initPopupText(this.currentNum)

    this.updateNextBtnView()

    this.updateAddToCart()

  }



  prevBtnEvent () {
    this.currentNum--
    if (this.currentNum < this.liList.length - 1) {
      this.nextBtn.classList.remove('disabled')
      this.nextBtn.removeAttribute('disabled')
      this.cartBtn.style.display = 'none'
      this.nextBtn.style.display = 'block'
      this.nextBtn.innerHTML = 'Next'
    }
    if (this.currentNum <= 0) {
      this.prevBtn.classList.add('disabled')
      this.prevBtn.setAttribute('disabled', true)
    } else {
      this.prevBtn.classList.remove('disabled')
      this.prevBtn.removeAttribute('disabled')
    }

    this.initViewClassification()
    this.initViewUl()
    this.updateNextBtnView()
  }

  addCartStatus(bool) {
    if (bool) {

      this.addCartBtn.querySelector('i.loading').style.display = 'inline-block'
      this.addCartBtn.classList.add('active')
      this.addCartBtn.setAttribute('disabled', true)


      this.cartBtn.querySelector('i.loading').style.display = 'inline-block'
      this.cartBtn.classList.add('active')
      this.cartBtn.setAttribute('disabled', true)

    } else {
      this.cartBtn.querySelector('i.loading').style.display = 'none'
      this.cartBtn.classList.remove('active')
      this.cartBtn.removeAttribute('disabled')

      this.addCartBtn.querySelector('i.loading').style.display = 'none'
      this.addCartBtn.classList.remove('active')
      this.addCartBtn.removeAttribute('disabled')
    }
  }

  initUlContent() {
    this.contentList.forEach((i, index) => {
      let iNum = 0
      this.currentInfoList[index] = {
        infoText: i.getAttribute('data-info-text'),
        productNumber: i.getAttribute('data-product-number')
      }

      i.querySelectorAll('.item-box').forEach(ii => {
        iNum++
        ii.querySelector('.product-btn').addEventListener('click', () => {
          if (this.isNextEvent()) return

          const productIndex = i.getAttribute('data-product-index')
          const productItem = ii.getAttribute('data-product-item')

          if (this.cartList[productIndex + '-' + productItem]) {
            this.cartList[productIndex + '-' + productItem].quantity++
          } else {
            this.cartList[productIndex + '-' + productItem] = {
              value: JSON.parse(ii.querySelector('[data-product-json]').innerHTML),
              quantity: 1,
              dom: ii
            }
          }

          ii.querySelector('.product-number-box').style.display = 'flex'
          ii.querySelector('.product-btn').style.display = 'none'
          ii.querySelector('.num').innerHTML = this.cartList[productIndex+'-'+productItem].quantity + ' Added'

          this.cartListType.push(productIndex)
          this.updateViewAddCart()
          this.updateNextBtnView(true)
          this.updateAddBtnView()

          this.updateUlLiStyle()

          this.updateAddToCart()

        })

        ii.querySelector('.add').addEventListener('click', () => {
          if (this.isNextEvent()) return
          this.productItemAdd(this.cartList[productIndex+'-'+productItem])
        })

        ii.querySelector('.reduce').addEventListener('click', () => {
          this.productItemReduce(this.cartList[productIndex+'-'+productItem], productIndex, productItem)
        })

        const productIndex = i.getAttribute('data-product-index')
        const productItem = ii.getAttribute('data-product-item')

        this.contentDataList[productIndex + '-' + productItem] = {
          value: JSON.parse(ii.querySelector('[data-product-json]').innerHTML),
          quantity: 1,
          dom: ii
        }
      })

      if (window.innerWidth < 750 && iNum >= 5) {
        i.classList.add('product-list-mobile')
        i.querySelector('.moreSpuImgBtn').addEventListener('click', () => {
          i.classList.remove('product-list-mobile')
        })
      }
    })
  }

  productItemAdd (item) {
    item.quantity = item.quantity + 1
    item.dom.querySelector('.num').innerHTML = item.quantity + ' Added'
    this.updateNextBtnView(true)
    this.updateViewAddCart()
    this.updateUlLiStyle()
    this.updateAddToCart()
    // 更新全局购物车

  }

  productItemReduce(item, index, itemIndex) {
    item.quantity = item.quantity - 1
    item.dom.querySelector('.num').innerHTML = item.quantity + ' Added'
    if (item.quantity <= 0) {
      const item = this.contentList[index].querySelectorAll('.item-box')[itemIndex]
      item.querySelector('.product-number-box').style.display = 'none'
      item.querySelector('.product-btn').style.display = 'block'
      item.querySelector('.num').innerHTML = '0 Added'
      this.cartListType.splice(this.cartListType.findIndex((ii) => ii === index), 1)

      delete this.cartList[index+'-'+itemIndex]
    }
    this.updateViewAddCart()
    this.updateNextBtnView(true)
    this.updateAddBtnView()
    this.updateUlLiStyle()
    this.updateAddToCart()
    // 更新全局购物车
  }

  initViewClassification () {
    this.liList.forEach((i, index) => {
      if (index > this.currentNum) {
        i.classList.remove('active')
      }
    })
    this.liList[this.currentNum].classList.add('active')
  }

  initViewUl () {
    this.contentList.forEach(i => {
      i.classList.remove('active')
    })
    this.contentList[this.currentNum].classList.add('active')
  }

  isNextEvent () {
    const { productNumber, cartListNumber} = this.getCurrentProductNumber()
    if (productNumber <= cartListNumber) {
      this.popupText.querySelector('.p-title').innerHTML = 'Reached purchase quantity'
      this.popupText.querySelector('.text-content').innerHTML = 'You have selected the maximum number of products'
      this.popupText.style.display = 'block'
      return true
    }
    return false
  }

  getCurrentProductNumber () {
    const productNumber = this.currentInfoList[this.currentNum].productNumber * 1
    let cartListNumber = 0
    for (let i in this.cartList) {
      const item = this.cartList[i]
      const b = i.split('-')[0] * 1

      if (b === this.currentNum) {
        cartListNumber += item.quantity
      }
    }
    return {
      productNumber,
      cartListNumber
    }
  }
  /**
   * 更新下一步的按钮
   */
  updateNextBtnView (bool = false) {
    const { productNumber, cartListNumber} = this.getCurrentProductNumber()

    if (productNumber > cartListNumber) {
      this.nextBtn.innerHTML = `(${ productNumber - cartListNumber } quantity)`
      this.nextBtn.classList.add('disabled')
      this.nextBtn.setAttribute('disabled', true)
    } else {
      this.nextBtn.innerHTML = `Next`
      this.nextBtn.classList.remove('disabled')
      this.nextBtn.removeAttribute('disabled')

      if (bool) {
        // 满足条件，下一步
        if (this.currentNum < this.contentList.length - 1) {
          setTimeout(() => {
            this.nextBtnEvent()
          }, 200)
        } else {
          this.updateAddToCart()
        }
      }
    }
  }

  // 更新 li 的样式内容
  updateUlLiStyle () {
    let data = {}
    for(let i in this.cartList) {
      const item = this.cartList[i]
      const b = i.split('-')[0]
      if (data[b]) {
        data[b] = data[b] + item.quantity
      } else {
        data[b] = item.quantity
      }
    }
    const nullData = []
    this.liList.forEach((i, index) => {
      if ((this.currentInfoList[index].productNumber * 1) === (data[index]) * 1) {
        i.classList.add('item-active')
      } else {
        i.classList.remove('item-active')
        nullData.push(index)
      }
    })
    return nullData
  }

  // 更新全局加入购物车按钮
  updateAddToCart (bool = true) {
    if (this.currentNum !== this.liList.length - 1 && bool) {
      return
    }

    let d0 = 0
    let d1 = 0
    for(let ii in this.cartList) {
      const items = this.cartList[ii]
      d0 += items.quantity
    }

    for(let ii in this.currentInfoList) {
      const items = this.currentInfoList[ii]
      d1 += items.productNumber * 1
    }

    if (d0 < d1) {
      this.nextBtn.style.display = 'block'

      this.addCartBtn.classList.add('disabled')
      this.addCartBtn.setAttribute('disabled', true)

      this.cartBtn.style.display = 'none'
      this.cartBtn.classList.add('disabled')
      this.cartBtn.setAttribute('disabled', true)
      this.price.classList.remove('active')
      this.price.querySelector('span').innerHTML = '(bundle final price)'
      return
    }

    if (d0 >= d1) {
      this.addCartBtn.classList.remove('disabled')
      this.addCartBtn.removeAttribute('disabled')

      this.cartBtn.classList.remove('disabled')
      this.cartBtn.removeAttribute('disabled')
      this.cartBtn.style.display = 'flex'
      this.nextBtn.classList.add('disabled')
      this.nextBtn.style.display = 'none'
      this.nextBtn.setAttribute('disabled', true)
      this.price.classList.add('active')
      this.price.querySelector('span').innerHTML = this.specialPrice( this.priceTotal)
    }
  }

  updateViewAddCart () {
    this.cartViewList.innerHTML = ''
    this.btnCart.querySelector('span').innerHTML = 0
    let p = 0
    let dsNumber = 0

    Object.keys(this.cartList).forEach((i) => {
      const item = this.cartList[i].value
      const box = document.createElement('div')
      box.className = 'box swiper-slide'
      const imgBox = document.createElement('div')
      imgBox.className = 'img'
      const imgSrc = document.createElement('img')
      imgSrc.src = item.featured_image
      imgBox.append(imgSrc)

      const infoBox = document.createElement('div')
      infoBox.className = 'info'
      const titleBox = document.createElement('div')
      titleBox.className = 'info-title'
      titleBox.innerHTML = item.title
      infoBox.append(titleBox)
      const priceBox = document.createElement('div')
      priceBox.className = 'info-price'
      const priceBoxSpan = document.createElement('span')
      const priceBoxI = document.createElement('i')
      priceBoxSpan.innerHTML = '$' + item.price / 100
      priceBoxI.innerHTML = 'x' + this.cartList[i].quantity

      priceBox.append(priceBoxSpan)
      priceBox.append(priceBoxI)
      infoBox.append(priceBox)

      const closeBox = document.createElement('div')
      closeBox.className = 'close'
      closeBox.innerHTML = '<svg class="icon" viewBox="0 0 1024 1024"><path d="M572.16 512l183.466667-183.04a42.666667 42.666667 0 1 0-60.586667-60.586667L512 451.84l-183.04-183.466667a42.666667 42.666667 0 0 0-60.586667 60.586667l183.466667 183.04-183.466667 183.04a42.666667 42.666667 0 0 0 0 60.586667 42.666667 42.666667 0 0 0 60.586667 0l183.04-183.466667 183.04 183.466667a42.666667 42.666667 0 0 0 60.586667 0 42.666667 42.666667 0 0 0 0-60.586667z"></path></svg>'
      closeBox.addEventListener('click', () => {
        delete this.cartList[i]
        const b = i.split('-')
        const item = this.contentList[b[0]].querySelectorAll('.item-box')[b[1]]
        item.querySelector('.product-number-box').style.display = 'none'
        item.querySelector('.product-btn').style.display = 'block'
        item.querySelector('.num').innerHTML = '0 Added'
        this.cartListType.splice(this.cartListType.findIndex((ii) => ii === b[0]), 1)
        const listArray =  this.updateUlLiStyle()
        if (listArray && listArray.length) {
          this.currentNum = listArray[0]
          this.initViewClassification()
          this.initViewUl()
        }

        this.updateViewAddCart()
        this.updateAddBtnView()
        this.updateNextBtnView(false)
        this.updateAddToCart(false)
      })
      box.append(imgBox)
      box.append(infoBox)
      box.append(closeBox)
      p = p + (item.price / 100) * this.cartList[i].quantity
      dsNumber = dsNumber + this.cartList[i].quantity
      this.priceTotal = p
      this.cartViewList.append(box)
      this.btnCart.querySelector('span').innerHTML = dsNumber
    })

    // this.price.innerHTML = this.specialPrice(dsNumber, p)
    this.upDateSwiper()
    if (!Object.keys(this.cartList).length) {
      this.btnCart.style.display = 'none'
    }
  }

  // 更新价格
  specialPrice (price) {
    // return  "$" + (price * (100 - n) / 100).toFixed(2) + " " + `<span style='text-decoration: line-through;font-size:0.6em; color: #999999;font-weight: 500;'>$${ price.toFixed(2) }</span>`
    return `<span style='text-decoration: line-through;'>$${ price.toFixed(2) }</span>`
  }

  viewKit () {
    const contentBox = this.box.querySelector('.right .r-content')
    const RClose = this.box.querySelector('.right .r-close')
    if (window.innerWidth <= 850) {
      contentBox.style.display = 'none'
    } else {
      this.btnCart.style.display = 'none'
      return
    }

    this.btnCart.addEventListener('click', () => {
      contentBox.style.display = 'block'
      this.btnCart.style.display = 'none'
    })

    RClose.addEventListener('click', () => {
      contentBox.style.display = 'none'
      this.btnCart.style.display = 'block'
    })
  }
  updateAddBtnView () {
    if (window.innerWidth >= 850) { return }
    const contentBox = this.box.querySelector('.right .r-content')
    if (Object.keys(this.cartList).length) {
      contentBox.style.display = 'block'
    } else {
      contentBox.style.display = 'none'
    }
  }

  initPopupText (index) {
    const num = index + 1

    const content = this.currentInfoList[index] && this.currentInfoList[index].infoText
    if (!content) { return }
    this.popupText.querySelector('.p-title').innerHTML = 'Step' + num
    this.popupText.querySelector('.text-content').innerHTML = content
    this.popupText.style.display = 'block'
  }

  // 动态生成 swiper
  initSwiper () {
    if (window.innerWidth >= 850) { return }
    this.swiperContentBox = new Swiper(this.options.swiperBox, {
      direction: 'vertical',
      slidesPerView : 1.4,
      centerInsufficientSlides: false
    })
  }

  upDateSwiper () {
    if (window.innerWidth >= 850) { return }
    this.swiperContentBox.update()
    setTimeout(() => {
      const num = Object.keys(this.cartList).length - 1
      this.swiperContentBox.slideTo(num)
    }, 200)
  }
}


